// 🔒
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// 🔒